 import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { HttpService } from '../../../services/http/http.service';

@Component({
  selector: 'app-new-test-time',
  templateUrl: './new-test-time.component.html',
  styleUrls: ['./new-test-time.component.scss']
})
export class NewTestTimeComponent implements OnInit {

  testTimesArr = ['15 min', '30 min', '45 min', '60 min'];
  digitExp = '^[0-9]*$';
  alphabetExp = '[a-zA-Z ]*$';
  testTime = new FormControl('', [Validators.required, Validators.pattern(this.digitExp)]);
  testName = new FormControl('', [Validators.required, Validators.pattern(this.alphabetExp), this.noWhitespaceValidator]);
  constructor(
    public dialogRef: MatDialogRef<NewTestTimeComponent>,
    private snackbar: MatSnackBar,
    private spinnerService: Ng4LoadingSpinnerService,
    private httpService: HttpService
  ) {
  }

  ngOnInit() {

  }
  closeDialog(flag: boolean): void {
    this.dialogRef.close(flag);
  }
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  getTestTimeErrorMessage() {
    return this.testTime.hasError('required') ? 'Test time is required' :
      this.testTime.hasError('pattern') ? 'Please provide valid test time' :
        '';
  }

  getTestNameErrorMessage() {
    return this.testName.hasError('required') ? 'Test name is required' :
      this.testName.hasError('pattern') ? 'Please provide valid test name' :
        this.testName.hasError('whitespace') ? 'Please provide valid test name' :
          '';
  }
  addTestTime() {
    var data = {
      testName: this.testName.value,
      testTime: this.testTime.value
    }
    if (this.testTime.value > 0) {
      console.log("Test time Data", data);
      this.spinnerService.show();
      var contentBody = { url: "/testtimes", body: data }
      this.httpService.httpPost(contentBody, true).subscribe(response => {
        console.log("success ", response);
        this.openSnackBar(response["message"]);
        this.spinnerService.hide();
        this.closeDialog(true);
      }, error => {
        console.log("error ", error);
        this.spinnerService.hide();
        this.openSnackBar(error.error.message);
      })
    }
    else {
      this.openSnackBar("Provide valid test time")
    }
  }

  openSnackBar(message: string) {
    this.snackbar.open(message, null, {
      duration: 2000,
    });
  }

  valueCheck() {
  }
}
